import React from 'react';
import PropTypes from 'prop-types';

// @ utilities
import { formatText, FormattedText } from 'core/i18n';
import StringIcon from 'utilities/StringIcon';

// @ constants
import { CREDIT_CARD_ICON_KEY_WORD, CREDIT_CARD_ICON_KEY_WORD_SA } from 'constants/creditCard/initialStepSections';
import { PRODUCT_SA } from 'constants/products';

//@ icons
import amazon from 'assets/icons/amazon.png';

const CreditCardFeatureInfo = ({ title, img, content, productStandard }) => {
    const iconKeyWord = productStandard === PRODUCT_SA ? CREDIT_CARD_ICON_KEY_WORD_SA : CREDIT_CARD_ICON_KEY_WORD;

    return (
        <div key={title} className="row tc-section-desc-feature">
            <img src={[img]} className="tc-section-desc-feature-icon" />
            <div className="tc-section-desc-feature-title">
                <div className="font-heading3">
                    <StringIcon value={formatText(title)} iconKeyWord={iconKeyWord} iconSrc={amazon} />
                </div>
                <FormattedText className="font-paragraph" value={content} />
            </div>
        </div>
    );
};

CreditCardFeatureInfo.propTypes = {
    title: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    productStandard: PropTypes.string.isRequired,
};

export default CreditCardFeatureInfo;
